import { render, staticRenderFns } from "./RecordAudio.vue?vue&type=template&id=3f8667e0"
import script from "./RecordAudio.vue?vue&type=script&lang=js"
export * from "./RecordAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports